import { render, staticRenderFns } from "./Pausenplan.vue?vue&type=template&id=2ecf7b5a&scoped=true"
import script from "./Pausenplan.vue?vue&type=script&lang=js"
export * from "./Pausenplan.vue?vue&type=script&lang=js"
import style0 from "./Pausenplan.vue?vue&type=style&index=0&id=2ecf7b5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecf7b5a",
  null
  
)

export default component.exports